/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LinkedRef: core.serialization.ObjectSchema<serializers.LinkedRef.Raw, Truvity.LinkedRef> =
    core.serialization.object({
        blobId: core.serialization.property('blob_id', core.serialization.string()),
        digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
        resourceId: core.serialization.property('resource_id', core.serialization.string()),
    });

export declare namespace LinkedRef {
    export interface Raw {
        blob_id: string;
        digest_multibase: string;
        resource_id: string;
    }
}
